import React from 'react';
import FeatureCard from './FeatureCard';
import '../styles/FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      title: "Activities",
      description: "Dive into adventure or unwind in paradise. Enjoy snorkeling, kayaking, sunset cruises, island walks, and exploring vibrant coral reefs — all just steps from your room at Turtles Bay.",
      href: "/activities"
    },
    {
      title: "Rooms",
      description: "Spacious, sea-facing rooms with all modern amenities — including TV, tea/coffee maker, private shower, and air-conditioning — for a relaxing island stay.",
      href: "/rooms"
    },
    {
      title: "Location",
      description: "Turtles Bay is set on Kadmat Island, Lakshadweep, a peaceful paradise of white sands, clear lagoons, and vibrant coral reefs. A perfect escape into nature and tranquility.",
      href: "/location"
    }
  ];

  return (
    <div className="features-container">
      <div className="features-grid">
        {features.map((feature) => (
          <FeatureCard key={feature.title} feature={feature} />
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
